import React from "react"
import types from "prop-types"
import { sortBy } from "lodash-es"
import { categoryShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import RequirementLevelSelectInput from "./RequirementLevelSelectInput"
import RequirementAction from "./RequirementAction"

const CategoryActions = ({ category, accessLevelOptions }) => (
  <div>
    <div className="flex justify-between w-full px-4 mb-2">
      <span className="font-bold text-sm text-dark">Name</span>
      <span className="w-48 shrink-0 font-bold text-sm text-dark">Access Needed</span>
    </div>
    {
      sortBy(category.accessLevelRequirements, ["id"]).map(({ id, action, accessLevel }, index) => (
        <ItemRow
          key={id}
          itemRowHeaderContent={(
            <div className="flex flex-row items-center justify-between gap-4 w-full">
              <RequirementAction id={id} index={index} value={action} />
              <RequirementLevelSelectInput
                action={action}
                name={`access_level_requirements_attributes[${index}].access_level`}
                accessLevelOptions={accessLevelOptions}
                value={accessLevel}
              />
            </div>
          )}
        />
      ))
    }
  </div>
)

CategoryActions.propTypes = {
  category: categoryShape.isRequired,
  accessLevelOptions: types.arrayOf(types.string).isRequired,
}

export default CategoryActions
